import aboutMutations from './about'
import eventsMutations from './events'
import webinarsMutations from './webinars'
import financialClubsMutations from './financialClubs'
import documentsMutations from './documents'
import normativeActsMutations from './normativeActs'
import requisitesMutatuions from './requisites'
import accountsMutations from './accounts'
import requiredInformationMutations from './requiredInformation'
import disclosureInformationMutations from './disclosureInformation'
import brokerInformationMutations from './brokerInformation'
import newsMutations from './news'
import serviceRequestsMutations from './serviceRequests'
import dataForClientsMutations from './dataForClients'
import additionalPagesMutations from './additionalPages'
import departmentsMutations from './departments'
import publicationsMutations from './publications'
import partnersMutations from './partners'
import historyMutations from './history'
import investmentMutations from './individualInvestment'
import loanMutations from './bondedLoan'
import investorMutations from './investor'
import redirectsMutations from './redirects'
import metaTagsMutations from './metaTags'
import financialClubInfoMutations from './financialClubInfo'
import commonServices from './commonServices'

export default {
  ...commonServices,
  ...newsMutations,
  ...aboutMutations,
  ...eventsMutations,
  ...partnersMutations,
  ...webinarsMutations,
  ...accountsMutations,
  ...historyMutations,
  ...documentsMutations,
  ...departmentsMutations,
  ...requisitesMutatuions,
  ...publicationsMutations,
  ...normativeActsMutations,
  ...dataForClientsMutations,
  ...financialClubsMutations,
  ...serviceRequestsMutations,
  ...additionalPagesMutations,
  ...brokerInformationMutations,
  ...requiredInformationMutations,
  ...disclosureInformationMutations,
  ...investmentMutations,
  ...loanMutations,
  ...investorMutations,
  ...redirectsMutations,
  ...metaTagsMutations,
  ...financialClubInfoMutations
}



// WEBPACK FOOTER //
// ./src/store/mutations/index.js